import React from 'react';
import { Modal, Button, Link, SpaceBetween, Box } from '@cloudscape-design/components';
import { ExportRecord } from '@amzn/controllershiphub-typescript-client';
import { downloadS3File } from 'src/utils/s3Download';

interface DownloadModalProps {
  exportRecord: ExportRecord;
  onClose: () => void;
}

export const DownloadModal: React.FC<DownloadModalProps> = ({ exportRecord, onClose }) => {
  const handleDownload = async (fileLink: string) => {
    try {
      await downloadS3File(fileLink);
    } catch (error) {
      console.error('Download error:', error);
      alert('Download failed. Please try again.');
    }
  };

  return (
    <Modal
      size="medium"
      header="Confirm Download"
      visible={true}
      onDismiss={onClose}
      footer={
        <Box float="right">
          <Button variant="primary" onClick={onClose}>
            Close
          </Button>
        </Box>
      }
    >
      <SpaceBetween direction="vertical" size="s">
        <Box>
          <strong>Export:</strong> {exportRecord.exportInfo?.exportName || 'N/A'}
        </Box>
        <Box>
          <strong>Files:</strong>
        </Box>
        <ul>
          {exportRecord.fileLinks?.map((fileLink, index) => {
            const fileName = fileLink.split('/').pop()?.split('?')[0] || `File ${index + 1}`;

            return (
              <li key={index}>
                <Link fontSize="inherit" external={true} onFollow={() => handleDownload(fileLink)}>
                  {fileName}
                </Link>
              </li>
            );
          })}
        </ul>
      </SpaceBetween>
    </Modal>
  );
};
